import React from 'react';
import BasicModal from './BasicModal';
import icon_delete from 'images/new_pop_ups/delete.svg';
import icon_duplicate from 'images/new_pop_ups/duplicate.svg';

const ProjectDuplicateModal = (props) => {
    let modalTypes = {
        duplicateProject: {
            title: 'Duplicate Project',
            description:
                'Please choose a name for the duplicated <br /> project or click “OK” for the default name <br />shown below.'
        }
    };
    return (
        <>
            <BasicModal
                title={modalTypes[props.modalType].title}
                visible={props.visible}
                onCancel={props.onCancel}
                icon={icon_duplicate}
                onAccept={props.onAccept}
                onAcceptTitle="OK"
            >
                <div>
                    <div>
                        <p
                            className="p-desctiption"
                            style={{ marginBottom: '50px' }}
                            dangerouslySetInnerHTML={{
                                __html: modalTypes[props.modalType].description
                            }}
                        ></p>
                    </div>
                    <div style={{}}>
                        <div>
                            <div
                                style={{
                                    padding: '5px 0 2px 0',
                                    color: '#828389'
                                }}
                            >
                                <input
                                    style={{
                                        padding: 5,
                                        // color: '#828389',
                                        color: '#000',
                                        width: '100%'
                                    }}
                                    onChange={props.handleProjectName}
                                    value={props.projectName}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </BasicModal>
        </>
    );
};

export default ProjectDuplicateModal;
